import { render, staticRenderFns } from "./eod-company-detail.vue?vue&type=template&id=d72afef2"
import script from "./eod-company-detail.vue?vue&type=script&lang=js"
export * from "./eod-company-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports